import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/query",
      name: "query",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/Login.vue"),
      children: [
        {
          path: "general/:mode",
          name: "general",
          component: () =>
            import(
              /* webpackChunkName: "generalLogin" */ "./components/GeneralLogin.vue"
            ),
          meta: {
            showNav: false
          }
        },
        {
          path: "qrCode",
          name: "qrCode",
          component: () =>
            import(/* webpackChunkName: "qrCode" */ "./components/QrCode.vue"),
          meta: {
            showNav: false
          }
        }
      ],
      meta: {
        showNav: false
      }
    },
    {
      path: "/payResult/:channel",
      name: "payResult",
      component: () =>
        import(/* webpackChunkName: "payResult" */ "./views/PayResult.vue"),
      meta: {
        title: "支付结果"
      }
    }
  ]
});
